import { Container } from "semantic-ui-react"

export const ClientManagerHome = () => {

  return (
    <Container>
      ClientManager home
    </Container>
  )
}